interface PaginatedRefetchOptions<TRefetchQuery> {
    refetchQueries: TRefetchQuery[];
    awaitRefetchQueries: true;
}

// For paginated/sorted lists, refetching after mutations prevents stale pages
// and ensures shifted rows are visible on the active page.
export function createPaginatedRefetchOptions<TRefetchQuery>(
    operationNames: readonly TRefetchQuery[]
): PaginatedRefetchOptions<TRefetchQuery>;
export function createPaginatedRefetchOptions<TRefetchQuery>(
    operationNames: TRefetchQuery
): PaginatedRefetchOptions<TRefetchQuery>;
export function createPaginatedRefetchOptions<TRefetchQuery>(
    operationNames: TRefetchQuery | readonly TRefetchQuery[]
): PaginatedRefetchOptions<TRefetchQuery> {
    const refetchQueries = Array.isArray(operationNames) ? [...operationNames] : [operationNames];

    return {
        refetchQueries,
        awaitRefetchQueries: true,
    };
}
